import axios from 'axios';
import React, { useCallback, useEffect, useRef, useState } from 'react'
import { Container, Row, Col, Card, Form, Pagination, InputGroup, Badge } from 'react-bootstrap';
import { IconSearch, IconX } from '@tabler/icons-react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import Loader from '../../Loader';
import { ViewCompanys } from './Modal/ViewCompanys';

const UserProfiles = () => {
    const [ViewCompanysShow, setViewCompanysShow] = React.useState(false);
    const [userCompanies, setUserCompanies] = useState({
        userId: null,
        companies: []
    });
    const [pagination, setPagination] = useState({
        limit: 10,
        skip: 0,
        pages: [],
        nextPage: false,
        currentPage: 1,
        previousPage: false
    });
    const [loader, setLoader] = useState(false);
    const [users, setUser] = useState([]);
    const token = useSelector((state) => state.token);
    const timerRef = useRef(null);
    const [searchKey, setSearchKey] = useState({ key: "" });
    const getUsers = (currentPage = 1, search = searchKey.key) => {
        setLoader(true);
        axios({
            method: "GET",
            url: `${process.env.REACT_APP_BASE_URL}/user?limit=${pagination.limit}&page=${currentPage}&search=${search}`,
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`
            }
        }).then(res => {
            setUser((prevState) => {
                return res.data.users;
            });
            setLoader(false);
            setPagination((preState) => ({
                ...preState,
                pages: res.data.pages,
                nextPage: res.data.nextPage,
                currentPage: res.data.currentPage,
                previousPage: res.data.previousPage
            }));
        }).catch(() => {
            setLoader(false);
        });
    }

    const changeActive = (userID, status) => {
        axios({
            method: "PUT",
            url: `${process.env.REACT_APP_BASE_URL}/user/status/${userID}`,
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`
            },
            data: JSON.stringify({
                status: status
            })
        }).then(res => {
            setUser((prevState) => (
                prevState.map((obj) => obj._id === userID ? { ...obj, active: status } : obj)
            ));
        }).catch(err => {
            if (err?.response?.data?.errors) {
                toast(err.response.data.errors[0].msg, {
                    theme: "light",
                    position: "top-right",
                    type: "error"
                });
            } else {
                toast(err?.response?.data?.message || err.message || "Error 500", {
                    theme: "light",
                    position: "top-right",
                    type: "error"
                });
            }
        });
    }

    const debounced = (value) => {
        if (timerRef.current) {
            clearTimeout(timerRef.current);
        }
        timerRef.current = setTimeout(() => {
            getUsers(1, value);
        }, 500);
    }

    useEffect(() => {
        getUsers(pagination.currentPage);
    }, []);

    return (
        <>
            <section className="admin_main full">
                <Container fluid>
                    <Row>
                        <Col md={12}>
                            <Card>
                                <Card.Header as="h5">
                                    <div className="d-flex align-items-center justify-content-between flex-wrap gap-3">
                                        <div className="head_title">
                                            <h3 className="mb-0">Users</h3>
                                        </div>
                                        <InputGroup className="w-auto search-box">
                                            <Form.Control
                                                value={searchKey.key}
                                                onChange={(e) => {
                                                    setSearchKey((prevState) => ({
                                                        ...prevState,
                                                        key: e.target.value
                                                    }));
                                                    debounced(e.target.value);
                                                }} placeholder="Search" type='search' />
                                            {searchKey.key?.length > 0 ?
                                                <InputGroup.Text onClick={() => {
                                                    setSearchKey((prevState) => ({ ...prevState, key: "" }));
                                                    debounced("")
                                                }} type="button" className='button'>
                                                    <IconX size={24} stroke={2} />
                                                </InputGroup.Text>
                                                :
                                                <InputGroup.Text
                                                    id="basic-addon1"
                                                    type="button"
                                                    onClick={() => {
                                                        if (searchKey.key?.length <= 0) {
                                                            return;
                                                        }
                                                        getUsers(1, searchKey.key);
                                                    }}
                                                    className='button'>
                                                    <IconSearch size={24} stroke={2} />
                                                </InputGroup.Text>
                                            }
                                        </InputGroup>
                                    </div>
                                </Card.Header>
                                <Card.Body>
                                    {users?.length > 0 ?
                                        <table className="client_table">
                                            <thead>
                                                <tr className="d-none d-lg-table-row">
                                                    <th width="16%">Date</th>
                                                    <th width="16%">Name</th>
                                                    <th width="20%">Email</th>
                                                    <th width="12%">Country</th>
                                                    <th width="12%">Phone</th>
                                                    <th width="6%">Kyc</th>
                                                    <th width="10%">Companies</th>
                                                    <th className='text-end' width="8%">Status</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {users.map((u, index) => {
                                                    return (<tr key={index} className="tr">
                                                        <td>
                                                            <strong className="ht">Date : </strong>
                                                            <small>{`${new Date(u.createdAt).toLocaleString()}`}</small>
                                                        </td>
                                                        <td>
                                                            <strong className="ht">Name : </strong>
                                                            <small>{u.userName}</small>
                                                        </td>
                                                        <td>
                                                            <strong className="ht">Email : </strong>
                                                            <small>{u.email}</small>
                                                        </td>
                                                        <td>
                                                            <strong className="ht">Country : </strong>
                                                            <small>{u.country}</small>
                                                        </td>
                                                        <td>
                                                            <strong className="ht">Phone : </strong>
                                                            <small>{u.phone}</small>
                                                        </td>
                                                        <td>
                                                            <strong className="ht">Kyc : </strong>
                                                            <small>{u.kyc ? <Badge bg="success">complete</Badge> : <Badge bg="danger">Incomplete</Badge>}</small>
                                                        </td>
                                                        <td>
                                                            <strong className="ht">Companies : </strong>
                                                            <p>
                                                                <button
                                                                    className="button yellow py-2 px-3"
                                                                    onClick={() => {
                                                                        setUserCompanies((prevState) => ({
                                                                            ...prevState,
                                                                            userId: u._id,
                                                                            companies: u.companies
                                                                        }));
                                                                        setViewCompanysShow(true)
                                                                    }}><small>View Companies</small></button>
                                                            </p>
                                                        </td>
                                                        <td align='right'>
                                                            <strong className="ht">Status : </strong>
                                                            <small>
                                                                <Form.Check
                                                                    onChange={() => {
                                                                        changeActive(u._id, !u.active);
                                                                    }}
                                                                    checked={u.active}
                                                                    type="switch"
                                                                    id={`custom-switch${index}`}
                                                                    label=""
                                                                    className='switch-toggle'
                                                                />
                                                            </small>
                                                        </td>
                                                    </tr>);
                                                })}
                                            </tbody>
                                        </table>
                                        : <p>Users not found</p>}
                                    <div className="d-flex justify-content-center mt-4">
                                        {pagination.previousPage || pagination.nextPage ?
                                            <Pagination>
                                                {pagination.previousPage ?
                                                    <Pagination.Item
                                                        onClick={() => { getUsers(pagination.currentPage - 1) }}
                                                        key={pagination.currentPage - 1}>
                                                        {pagination.currentPage - 1}
                                                    </Pagination.Item>
                                                    : null}
                                                <Pagination.Item
                                                    active>
                                                    {pagination.currentPage}
                                                </Pagination.Item>
                                                {pagination.nextPage ?
                                                    <Pagination.Item
                                                        onClick={() => { getUsers(pagination.currentPage + 1) }}
                                                        key={pagination.currentPage + 1}>
                                                        {pagination.currentPage + 1}
                                                    </Pagination.Item>
                                                    : null}
                                            </Pagination>
                                            : null}
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </section>
            <Loader show={loader} />

            <ViewCompanys
                show={ViewCompanysShow}
                data={userCompanies}
                getData={() => {getUsers()}}
                onHide={() => setViewCompanysShow(false)}
            />
        </>
    )
}

export default UserProfiles